import { render, staticRenderFns } from "./CaseLedger.vue?vue&type=template&id=52f27c34&scoped=true"
import script from "./CaseLedger.vue?vue&type=script&lang=js"
export * from "./CaseLedger.vue?vue&type=script&lang=js"
import style0 from "./CaseLedger.vue?vue&type=style&index=0&id=52f27c34&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52f27c34",
  null
  
)

export default component.exports